import Plyr from 'plyr'

const youtubeVideoDialogs = document.querySelectorAll("dialog.video-iframe");
const fileVideoDialogs = document.querySelectorAll("dialog.video-file");

// Helper to detect iOS
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// Load YouTube API
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
document.head.appendChild(tag);

// Shared player initializer
function initYoutubePlayer(dialog, playOnReady = false) {
  const videoHolder = dialog.querySelector('.video-holder');
  const videoHtml = atob(dialog.getAttribute('data-video-html'));
  videoHolder.innerHTML = videoHtml;

  const videoEl = videoHolder.querySelector('iframe');
  if (!videoEl) {
    console.error('No video iframe found in dialog');
    return null;
  }

  const videoUrl = videoEl.src;
  const videoId = videoUrl.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i)?.[1];
  if (!videoId) {
    console.error('Could not extract YouTube video ID');
    return null;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'plyr__video-embed';
  wrapper.setAttribute('data-plyr-provider', 'youtube');
  wrapper.setAttribute('data-plyr-embed-id', videoId);

  videoEl.parentNode.replaceChild(wrapper, videoEl);
  wrapper.appendChild(videoEl);

  const player = new Plyr(wrapper, {
    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
    youtube: {
      noCookie: true,
      rel: 0,
      showinfo: 0,
      iv_load_policy: 3,
      modestbranding: 1
    }
  });

  player.on('ready', () => {
    console.log('Plyr is ready');
    if (playOnReady) {
      setTimeout(() => player.play(), 100);
    }
  });

  player.on('error', (error) => {
    console.error('Plyr error:', error);
  });

  return player;
}

// Handle YouTube videos
youtubeVideoDialogs.forEach((dialog) => {
  let player = null;

  if (isIOS()) {
    const button = document.querySelector(`button[popovertarget="${dialog.id}"]`);
    // Init player immediately. This is a workaround for iOS.
    if (!player) {
      player = initYoutubePlayer(dialog);
    }
    button?.addEventListener('click', () => {
      setTimeout(() => player?.play(), 100);
    });

    dialog.addEventListener('beforetoggle', (event) => {
      if (event.newState === 'closed' && player) {
        player.pause();
      }
    });
  } else {
    dialog.addEventListener('beforetoggle', (event) => {
      if (event.newState === 'open') {
        if (!player) {
          player = initYoutubePlayer(dialog, true);
        } else {
          setTimeout(() => player.play(), 100);
        }
      } else if (event.newState === 'closed') {
        player?.pause();
      }
    });
  }
});

// Handle <video> files
fileVideoDialogs.forEach((dialog) => {
  dialog.addEventListener('beforetoggle', (event) => {
    const video = dialog.querySelector('video');
    if (event.newState === 'open') {
      setTimeout(() => video?.play(), 100);
    } else if (event.newState === 'closed') {
      video?.pause();
    }
  });
});
